import {
    Modal,
    Route,
} from './types'
import {
    push,
    replace,
} from './actions'
import {
    useEffect,
    useState,
} from 'react'
import {handleModal} from './modals'
import {useAppDispatch} from '../hooks'

interface Navigate {
    method: typeof push | typeof replace
    route: Route
}

export interface Routing {
    isPending: boolean
    popModal: (modal: Modal) => void
    pushRoute: (newRoute: Route) => void
    replaceRoute: (newRoute: Route) => void
}

export const useRouting = (): Routing => {
    const [isPending, setIsPending] = useState(false)
    const [modal, setModal] = useState<Modal>()
    const [navigate, setNavigate] = useState<Navigate>()

    const dispatch = useAppDispatch()

    useEffect(() => {
        if (modal) {
            handleModal(modal)
        }
    }, [modal])

    useEffect(() => {
        if (navigate) {
            dispatch(navigate.method(navigate.route))
                .unwrap()
                .catch(() => undefined)
                .finally(() => {
                    setIsPending(false)
                })
        }
    }, [navigate])

    const popModal = (newModal: Modal) => {
        setModal(newModal)
    }

    const pushRoute = (newRoute: Route) => {
        if (!isPending) {
            setIsPending(true)
            setNavigate({
                method: push,
                route: newRoute,
            })
        }
    }

    const replaceRoute = (newRoute: Route) => {
        if (!isPending) {
            setIsPending(true)
            setNavigate({
                method: replace,
                route: newRoute,
            })
        }
    }

    return {
        isPending,
        popModal,
        pushRoute,
        replaceRoute,
    }
}
